import { AddMemberToAffiliateFirmProps } from '@commenda/types';
import { fetcher } from '@commenda/utils';

export async function addMemberToAffiliateFirm(
  body: AddMemberToAffiliateFirmProps
) {
  const queryParams = body.userId ? `?userId=${body.userId}` : '';
  const response = await fetcher(
    `affiliate-firms/${body.affiliateFirmId}/member${queryParams}`,
    {
      method: 'POST',
      body: body.user,
    }
  );

  return response;
}
